import { useEffect, useState } from "react";
import DataTable from "../../component/DataTable";
import { Link } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const DeleteEndpoint = ApiEndpoints.eguide.Delete;
const ListEndpoint = ApiEndpoints.eguide.List;
const EditPath = "edit-eguide";
const tableHeader = ["Date", "Title"];
const tbody = ["createdAt", "title"];

export default function Eguide() {

  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", ListEndpoint);
      const result = response.eguides;
      setData(result);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    dataFetch();
  }, []);

  const handleDelete = async (eguide_id) => {
    const payload = { eguide_id };
    try {
      const response = await ApiRequest("POST", DeleteEndpoint, payload);
      toast.success(response.message)
      dataFetch();
    } catch (error) {
      console.error(error);
    }
  };

  const pagename = {
    name: 'E-guide Management',
    user: 'Admin',
    innerpage: 'E-guide Management / E-guides'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-eguide">Add +</Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={EditPath}
          onDelete={handleDelete}
        />
      </div>
    </>
  );
}
